// TODO(ngen): rewrite these somewhere else

const process = {
  env: {
    ESLINT_NO_DEV_ERRORS: true,
    PORT: '3001',
    REACT_APP_PUBLIC_PATH: 'http://localhost:3001/',
    REACT_APP_EPPSAPI_PROTO_AND_DOMAIN: 'https://awsdev.epps.rd.elliemae.io',
    REACT_APP_API_PROTO_AND_DOMAIN: 'https://int.api.elliemae.com',
    REACT_APP_EPPSWIDGET_SERVER_API:
      'https://partnerapi.awsdev.epps.rd.elliemae.io',
    REACT_APP_LOANCATCHER_API:
      'https://api.d2.lcdev.epps.rd.elliemae.io/api/v1',
    REACT_APP_EPPSAPI_VERSION: '/API/v2',
    REACT_APP_EPPSWIDGET_SERVER_VERSION: '/v1',
    REACT_APP_BASIC_TOKEN:
      'Basic a2Vsczdpc3E6T1Y3MlhFYmZIUm81NGw1bDlkSlptMHI0eGlKTVd4ZXg2SnhmVEFFY0kyZjFHdmVxSDNCeWI2Zkl5Nkt6SFJzdg==',
    REACT_APP_EM_CLIENT_ID: '24ah8nur',
    REACT_APP_EM_CLIENT_SECRET: '',
    REACT_APP_RESPONSE_TYPE: 'code',
    REACT_APP_EM_SCOPE: 'ccbp cc',
    REACT_APP_NODE_PATH: 'src/',
    REACT_APP_ENV_NAME: 'dev',
    REACT_APP_DEBUG_BUYSIDE: false,
    REACT_APP_APPLY_EPPS_LOCKDESK_SETTINGS: false,
    REACT_APP_SHOW_PRICING_DETAILS: true,
  },
} as any;

// Environment specific config
export const DEFAULT_LOGIN_DEST = '/authentication/';
export const APPLY_EPPS_LOCKDESK_SETTINGS =
  `${process.env.REACT_APP_APPLY_EPPS_LOCKDESK_SETTINGS}` === 'true';
export const PRICING_DETAILS =
  `${process.env.REACT_APP_SHOW_PRICING_DETAILS}` === 'true';
// adapted for react-scripts
export const BASIC_TOKEN = `${process.env.REACT_APP_BASIC_TOKEN}`;
export const EPPSWIDGET_SERVER_API = `${process.env.REACT_APP_EPPSWIDGET_SERVER_API}`;
export const EPPSAPI_PROTO_AND_DOMAIN = `${process.env.REACT_APP_EPPSAPI_PROTO_AND_DOMAIN}`;
export const EPPS_LOANCATCHER_API = `${process.env.REACT_APP_LOANCATCHER_API}`;
export const API_PROTO_AND_DOMAIN = `${process.env.REACT_APP_API_PROTO_AND_DOMAIN}`;
export const BP_PROTO_AND_DOMAIN = `${process.env.REACT_APP_BP_PROTO_AND_DOMAIN}`;
export const DEBUG_BUYSIDE =
  `${process.env.REACT_APP_DEBUG_BUYSIDE}` === 'true';
export const DATA_SOURCE_BUYSIDE =
  'urn:elli:services:form:secondarylock:getbuysidepricing';
export const DATA_SOURCE_SELLSIDE =
  'urn:elli:services:form:secondarylock:getsellsidepricing';
export const EM_CLIENT_ID = `${process.env.REACT_APP_EM_CLIENT_ID}`;
export const RESPONSE_TYPE = `${process.env.REACT_APP_RESPONSE_TYPE}`;
export const EM_SCOPE = `${process.env.REACT_APP_EM_SCOPE}`;
export const PA_VIEW = `${process.env.REACT_APP_PA_VIEW}`;
export const EPPSAPI_VERSION = `${process.env.REACT_APP_EPPSAPI_VERSION}`;
export const EPPSWIDGET_SERVER_VERSION = `${process.env.REACT_APP_EPPSWIDGET_SERVER_VERSION}`;
export const ENV_NAME = `${process.env.REACT_APP_ENV_NAME}`;
// Configs for all envs
export const PUBLIC_PATH =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3001/' : '/';
export const AUTH_TOKEN = 'access_token';
export const STORAGE_PREFIX = 'EM_EPPS';
export const TOKEN_KEY = `${STORAGE_PREFIX}-token`;
export const PAT_TOKEN_KEY = `${STORAGE_PREFIX}-PATtoken`;
export const TRANS_ID_KEY = `${STORAGE_PREFIX}-TRANSID`;
export const JWT_TOKEN_KEY = `${STORAGE_PREFIX}-JWTtoken`;
export const USER_TYPE_KEY = `${STORAGE_PREFIX}-UserType`;
export const BORROWER_ID_KEY = `${STORAGE_PREFIX}-BorrowerID`;
export const WEBHOOKTOKEN_KEY = `${STORAGE_PREFIX}-Webhooktoken`;
export const HOSTAPPLICATION_KEY = `${STORAGE_PREFIX}-HostApplication`;
export const ORIGIN_ID_KEY = `${STORAGE_PREFIX}-ORIGINID`;
export const CRED_KEY = `${STORAGE_PREFIX}-Credentials`;
export const SUMMARY_PARAMS = `${STORAGE_PREFIX}-Summary`;
export const GRANT_AND_SCOPE = `grant_type=client_credentials&scope=${encodeURIComponent(
  'pc pcapi',
)}`;
export const SESSION_SECONDS_OK = 900;
export const SESSION_SECONDS_WARN = 60;
export const SESSION_SECONDS_EXPIRE = 0;
export const SESSION_STATE_OK = 0;
export const SESSION_STATE_WARN = 1;
export const SESSION_STATE_EXPIRE = 2;
export const SESSION_STATE_LOGOUT = 3;
export const SESSION_STATE_CREATE_ACCT = 4;
export const SESSION_SAVE_CHANGES =
  'You have unsaved changes. Are you sure you want to navigate away?';
export const OAPI_SESSION_SECONDS_TOKEN_REFRESH_INTERVAL = 600; // 10 minutes
export const TOUCH_ENABLED =
  // eslint-disable-next-line no-restricted-syntax
  'ontouchstart' in window || (navigator as any).msMaxTouchPoints > 0;
